// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DRJv4mliuVURaJ8aErK3{grid-template-columns:auto max-content;justify-content:flex-start;align-items:center;gap:4px;width:100%;display:grid;position:relative}.iOyDCC8sn8kzVorc2GLN{position:absolute;right:-4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DRJv4mliuVURaJ8aErK3`,
	"actions": `iOyDCC8sn8kzVorc2GLN`
};
export default ___CSS_LOADER_EXPORT___;
